import { Auth } from '@aws-amplify/auth';
import { LoaderFunctionArgs, replace } from 'react-router-dom';

import { getAuthPageUrl } from '../../features/authentication/helpers/functions/url';

export async function authenticationLoader({ request }: LoaderFunctionArgs) {
  try {
    await Auth.currentSession();
  } catch {
    const url = new URL(request.url);

    return replace(
      `${import.meta.env.VITE_CHECKOUT_URL}${getAuthPageUrl({
        redirectedFrom: `/${url.search}`,
      })}`,
    );
  }

  return null;
}
